import { Controller } from "@hotwired/stimulus"

// Segmented picker for the onboarding lanes (and the nested CLI agent/manual
// toggle — its own controller instance, so targets don't leak across). Shows
// one pane at a time, keeps tab ARIA state in sync, and supports arrow-key
// navigation on the tablist.
export default class extends Controller {
  static targets = ["tab", "lane", "laneLink"]

  connect() {
    this.element.setAttribute("data-ready", "")
  }

  disconnect() {
    this.element.removeAttribute("data-ready")
  }

  select(event) {
    this.#activate(event.currentTarget)
  }

  key(event) {
    if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return
    event.preventDefault()
    const tabs = this.tabTargets
    const current = tabs.findIndex((tab) => tab.getAttribute("aria-selected") === "true")
    const delta = event.key === "ArrowRight" ? 1 : tabs.length - 1
    const next = tabs[(Math.max(current, 0) + delta) % tabs.length]
    this.#activate(next)
    next.focus()
  }

  #activate(tab) {
    const key = tab.dataset.lane
    this.laneTargets.forEach((lane) => {
      lane.classList.toggle("hidden", lane.dataset.lane !== key)
    })
    this.tabTargets.forEach((t) => this.#paint(t, t === tab))
    this.#carryLane(key)
  }

  // Links that reload the page (the "Check my connection" control) would come
  // back on the server's default lane, losing the instructions the user was
  // reading. Keep their ?lane= in step with the visible pane.
  #carryLane(key) {
    this.laneLinkTargets.forEach((link) => {
      const url = new URL(link.href, window.location.origin)
      url.searchParams.set("lane", key)
      link.href = url.pathname + url.search
    })
  }

  #paint(tab, active) {
    tab.classList.toggle("bg-[var(--color-kova-accent)]", active)
    tab.classList.toggle("text-white", active)
    tab.classList.toggle("text-[var(--color-kova-muted)]", !active)
    tab.setAttribute("aria-selected", active ? "true" : "false")
  }
}
